import { render, staticRenderFns } from "./ServicesOffers.vue?vue&type=template&id=b80ad0f6&"
import script from "./ServicesOffers.vue?vue&type=script&lang=js&"
export * from "./ServicesOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports